import { setupContinueWithEmail } from 'util/loginAndSignupForms';
import getSignUpTrackers from 'util/getSignupTrackers';

document.addEventListener('DOMContentLoaded', () => {
  setupContinueWithEmail('new_session');
  getSignUpTrackers();
});
